export default __webpack_public_path__ + "static/media/fsw_2.9eca4c6c.png";